/**
 * Блокирует бесполезные символы в input['number'].
 * Благодаря этой функции можно ввести только положительное число и пропускать экспоненту и знак плюса
 */
export const blockEAndDashKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if ([ '-', '+', 'e', 'E' ].includes(event.key)) event.preventDefault();
};
